class Users {
  constructor(appAPI, usersListsManager, entitiesFormatter) {
    'ngInject';

    this.appAPI = appAPI;
    this.usersListsManager = usersListsManager;
    this.entitiesFormatter = entitiesFormatter;
  }
  new(name, email, scopeId) {
    return this.appAPI.newUser(name, email, scopeId);
  }
  edit(userId, name, email) {
    return this.appAPI.editUser(
      userId,
      name,
      email,
    );
  }
  reactivate(email) {
    return this.appAPI.reactivateUser(email);
  }
  import(email) {
    return this.appAPI.importUser(email);
  }
  delete(userId) {
    return this.appAPI.deleteUser(userId);
  }
  removeAccess(userId) {
    return this.appAPI.removeUserAccess(userId);
  }
  newList() {
    return this.usersListsManager.newList();
  }
  byId(userId) {
    return this.appAPI.user(userId)
    .then((response) => this.entitiesFormatter.user(response));
  }
  permissionsForBrand(userId, brandId) {
    return this.appAPI.permissionsForBrand(userId, brandId);
  }
  rolesForBrand(userId, brandId, scopeId) {
    return this.appAPI.rolesForBrand(userId, brandId, scopeId);
  }
  brandAdminSettings(userId) {
    return this.appAPI.userBrandAdminSettings(userId)
    .then((response) => ({
      brands: response.customer_accounts.map((brand) => this.entitiesFormatter.brand(brand)),
    }));
  }
  saveBrandAdminSettings(userId, brandIds) {
    return this.appAPI.saveUserBrandAdminSettings(userId, brandIds);
  }
  getActivities(userId, options) {
    return this.appAPI.getUserActivities(userId, options);
  }
  getActivitiesDownloadURL(userId) {
    return this.appAPI.getUserActivitiesDownloadURL(userId);
  }
}

export default Users;
